/* eslint-disable react/no-danger */
import * as React from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    // Display fallback UI
    this.setState({ hasError: true, info: errorInfo, error });
  }

  render() {
    const { children } = this.props;
    const { info, error, hasError } = this.state;
    if (hasError) {
      return (
        <div>
          <h1 level="1">Something went wrong.</h1>
          <div>{error.message}</div>
          <div>{JSON.stringify(info).replace(/\\n/g, " ")}</div>
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  team: PropTypes.string
};

ErrorBoundary.defaultProps = {
  team: undefined
};

export default ErrorBoundary;
